import PropTypes from 'prop-types';
export var position = {
  LEFT: 'left',
  RIGHT: 'right'
};
export var positionPropType = PropTypes.oneOf(Object.values(position));